import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { tagsActions } from '@src/store/reducers/tagTypesReducer';

export const createTagTypesMiddleware = (http: any, successPopUp: any, errorPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [tagsActions.CREATE_TAG_TYPE]: async (action: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}Tags/TagType`, action.payload.tagType);
            const data = response.data;
            if (!data) {
                errorPopUp();
            } else {
                successPopUp();
                next({ type: action.type, payload: data });
            }
        },
        [tagsActions.GET_TAG_TYPES_LIST]: async (action: any, next: Next) => {
            const url = `${restServiceUrl}Tags/TagType/PageNumber/${action.payload.pageNumber}/PageSize/${action.payload.pageSize}`;
            const response = await http.get(url);
            const data = response.data;
            next({ type: action.type, payload: data });
            return data;
        },
        [tagsActions.UPDATE_TAG_TYPE]: async ({ payload }: any) => {
            const response = await http.put(`${restServiceUrl}Tags/TagType`, payload.tagType);
            const data = response.data;
            if (!data) {
                errorPopUp();
            } else {
                successPopUp();
            }
            return data;
        },
        [tagsActions.DELETE_TAG_TYPE]: async ({ payload }: any, next: Next) => {
            try {
                const response = await http.delete(`${restServiceUrl}Tags/TagType/${payload.tagTypeId}`);
                const data = response.data;
                if (!data) {
                    errorPopUp();
                } else {
                    successPopUp();
                }
                next({ type: tagsActions.REFRESH_DELETE_TAG_TYPE, payload: payload.tagTypeId });
                return response;
            } catch (error) {
                return error;
            }
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/tag-types.middleware.ts